import { render } from "./HistoryIndex.vue?vue&type=template&id=d2256d3e&scoped=true"
import script from "./HistoryIndex.vue?vue&type=script&lang=js"
export * from "./HistoryIndex.vue?vue&type=script&lang=js"

import "./HistoryIndex.vue?vue&type=style&index=0&id=d2256d3e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2256d3e"]])

export default __exports__